import React from 'react';
import StateMessage from '../StateMessage/StateMessage';

const NoData = ({ label, onClick }) => (
  <StateMessage
    illustration={'lineal_liquidaciones_empty'}
    title={label}
    subtitle={'Empezá a vender ahora generando un link de pago'}
    button={{
      icon: 'historial-btn-pago',
      iconAlign: 'left',
      text: 'Link de pago',
      onClick,
    }}
  />
);

export default NoData;
